"use client";

import { c as _c } from "react/compiler-runtime";
import { useLocale } from "@repo/design-system/hooks/use-locale";
import { useClient } from "@repo/design-system/utils/client/client";
const IMAGES: Record<string, Record<string, {
  large: string;
  small: string;
}>> = {
  eon: {
    en: {
      large: "images/header/eon_headerimage_desktop.webp",
      small: "images/header/eon_headerimage_mobile.webp"
    },
    de: {
      large: "images/header/eon_headerimage_desktop.webp",
      small: "images/header/eon_headerimage_mobile.webp"
    },
    hu: {
      large: "images/header/eon_headerimage_desktop.webp",
      small: "images/header/eon_headerimage_mobile.webp"
    },
    ro: {
      large: "images/header/eon_headerimage_desktop.webp",
      small: "images/header/eon_headerimage_mobile.webp"
    },
    sv: {
      large: "images/header/eon_headerimage_desktop.webp",
      small: "images/header/eon_headerimage_mobile.webp"
    },
    cs: {
      large: "images/header/eon_headerimage_desktop.webp",
      small: "images/header/eon_headerimage_mobile.webp"
    }
  },
  econ: {
    de: {
      large: "images/header/subclients/econ/new_header_jobboard_desktop.webp",
      small: "images/header/subclients/econ/new_header_jobboard_mobile.webp"
    },
    en: {
      large: "images/header/subclients/econ/new_header_jobboard_desktop.webp",
      small: "images/header/subclients/econ/new_header_jobboard_mobile.webp"
    }
  },
  uk: {
    en: {
      large: "images/header/subclients/uk/jobboard_desktop.webp",
      small: "images/header/subclients/uk/jobboard_mobile.webp"
    }
  }
};
const CLIENTS_WITHOUT_HEADER_IMAGE = new Set(["hungary"]);
export const useHeaderImage = () => {
  const $ = _c(4);
  const client = useClient();
  const locale = useLocale();
  if (CLIENTS_WITHOUT_HEADER_IMAGE.has(client || "")) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        largeImageSrc: "",
        smallImageSrc: "",
        revealImage: false,
        showHeaderImage: false
      };
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const imageSet = IMAGES[client || "eon"]?.[locale || "en"] || IMAGES.eon[locale || "en"] || IMAGES.eon.en;
  let t0;
  if ($[1] !== imageSet.large || $[2] !== imageSet.small) {
    t0 = {
      largeImageSrc: imageSet.large,
      smallImageSrc: imageSet.small,
      revealImage: true,
      showHeaderImage: true
    };
    $[1] = imageSet.large;
    $[2] = imageSet.small;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};